module.exports = __webpack_public_path__ + "static/media/emblema.849ffc1d.png";